import { Component, ViewChild, TemplateRef, Inject } from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { CompsDataService } from "../../comps-page/comps-data.service";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { AppService } from "src/app/app.service";
import { MARKETDATA_COPYRIGHT_MESSAGE } from "src/app/common-constants";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { getSelectedPeriods } from "src/app/utils/period-utils";
import {
  ValuationGridData,
  ValuationPeriodState,
  UserSettingObject,
} from "src/app/valuation-page/valuation-page.model";
import { ValuationPageDataService } from "src/app/valuation-page/valuation-page-data.service";
import {
  getSelectedRatiosId,
  getIsDenomSelected,
  getIsDenomYoySelected,
  createGridData,
  createDataCallUrlV1,
} from "src/app/valuation-page/valuation-page-utils";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
import {
  PeriodState,
  PeriodUserSettingObj,
  convertPeriodMetaToUserSettings,
} from "@va/core-library/period-filter";
import { SectorsAndIndustriesPageDataService } from "../sectors-and-industries-page-data-service";
import { ActivatedRoute, Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
  ANALYTICS_FEATURE_NAME,
  INDUSTRY_PAGE_INFO,
} from "src/app/sectors-and-industries-page/sector-and-industry-page-constants";
import {
  SetSectorIndustry,
  SetIndustrySubHeader,
  SetIndustryMengMenuVisibility,
} from "src/app/store/actions/sector-industry.actions";
import { DeleteDpParams } from "src/app/store/actions/global-subheader.actions";
import {
  IndustryMeta,
  SectorIndustry,
  SectorMetaResponse,
} from "src/app/store/models/industry-page.model";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import { createUserIndustrySettings } from "src/app/sectors-and-industries-page/sector-and-industry-page-utils";
import { faThLarge } from "@fortawesome/pro-light-svg-icons";
import { MegaMenuService } from "../mega-menu.service";
import { forkJoin, Observable, Subscription, from } from "rxjs";
import { mergeMap } from "rxjs/operators";
import {
  VAIconRegistryService,
  check,
  close,
  closeCircle,
  infoCircle,
  menu,
} from "@va/core-library/icons";
@Component({
  selector: "app-industry-valuation",
  templateUrl: "./industry-valuation.component.html",
  styleUrls: ["./industry-valuation.component.scss"],
  host: { class: "industry-page-container" },
})
export class IndustryValuationComponent {
  //icons
  faThLarge = faThLarge;

  // loaders
  isMetaInProgress = true;
  isDataInProgress = true;
  isUserSettingUpdateInProgress = false;
  isExportInProgress = false;
  isLineItemUpdateInProgress = false;

  // filters data
  sector;
  industry;
  ratioLineItemsData = [];
  suggestedRatioLines = [];
  ratios;
  orderedRatioData;
  tickers = [];
  currency = "";
  periodData: PeriodState = undefined;
  periodUserSetting: PeriodUserSettingObj = undefined;
  userSettingDetails: UserSettingObject;
  periodCalculation;
  orientationValue = "grid";
  periodsWithAvailableData;

  // instance variables
  pageShortName = INDUSTRY_PAGE_INFO.valuation.shortName;
  industryId: number;
  gridData: ValuationGridData = undefined;
  magnitudeMessage;
  periodList: Array<string>;
  lineItemMaxLimit = 20;
  selectedLineItemCount = 0;
  selectedRatioId;
  highlightGAAP = false;
  lineItemsModal: NzModalRef;
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: false,
    },
  ];
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "default",
  };
  marketDataCopyRightMessage = MARKETDATA_COPYRIGHT_MESSAGE;
  marketDataAccess = false;
  apiEP: string = window.apiUrl;
  marketCap = [-1];
  region = [-1];
  countries;
  subGroup = -1;

  //popovers
  isMegaMenuVisible = false;
  regionPopoverOpen = false;
  isExportPopoverVisible = false;
  isNoTickerPopupVisible = false;

  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  //urls
  legacyUrl = `${window.caUrl}/app`;

  //subscribers
  routeParamSubscriber: Subscription;
  sectorIndustryStoreSubscriber: Subscription;
  sectorIndustryStoreReloadSubscriber: Subscription;
  sectorIndustryStoreHasDataSubscriber: Subscription;
  sectorMetaSubscriber: Subscription;
  industryDetailsSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;
  valuationMetaSubscriber: Subscription;
  valuationDataSubscriber: Subscription;
  valuationDataFirstBatchSubscriber: Subscription;
  valuationDataSecondBatchSubscriber: Subscription;
  userTabSettingsSubscriber: Subscription;
  userIndustrySettingsSubscriber: Subscription;
  lineItemsSubscriber: Subscription;
  currencyMessageSubscriber: Subscription;

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  constructor(
    private dataService: SectorsAndIndustriesPageDataService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    public router: Router,
    private appService: AppService,
    private valuationDataService: ValuationPageDataService,
    private modalService: NzModalService,
    private compsDataService: CompsDataService,
    private megaMenuService: MegaMenuService,
    private iconRegistry: VAIconRegistryService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    this.iconRegistry.registerIcons([
      menu,
      check,
      close,
      closeCircle,
      infoCircle,
    ]);
  }

  /**
   * Unsubscribes from store when component is destroyed
   */
  ngOnDestroy(): void {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreSubscriber) {
      this.sectorIndustryStoreSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreReloadSubscriber) {
      this.sectorIndustryStoreReloadSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreHasDataSubscriber) {
      this.sectorIndustryStoreHasDataSubscriber.unsubscribe();
    }
    if (this.industryDetailsSubscriber) {
      this.industryDetailsSubscriber.unsubscribe();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
    if (this.valuationMetaSubscriber) {
      this.valuationMetaSubscriber.unsubscribe();
    }
    if (this.valuationDataSubscriber) {
      this.valuationDataSubscriber.unsubscribe();
    }
    if (this.valuationDataFirstBatchSubscriber) {
      this.valuationDataFirstBatchSubscriber.unsubscribe();
    }
    if (this.valuationDataSecondBatchSubscriber) {
      this.valuationDataSecondBatchSubscriber.unsubscribe();
    }
    if (this.userTabSettingsSubscriber) {
      this.userTabSettingsSubscriber.unsubscribe();
    }
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    if (this.currencyMessageSubscriber) {
      this.currencyMessageSubscriber.unsubscribe();
    }
    if (this.userIndustrySettingsSubscriber) {
      this.userIndustrySettingsSubscriber.unsubscribe();
    }
    if (this.valuationDataService) {
      this.valuationDataService.destroyValuationGridData();
    }
    this.dismissSnackBar();
  }

  /**
   * On initialization, it checks for industry id from routes
   * It resets filters value
   * Make call to get Industry meta and stores it
   */
  ngOnInit() {
    this.routeParamSubscriber = this.route.params.subscribe((paramData) => {
      const industryId = paramData.industryId;
      this.industryId = parseInt(industryId);
      this.subGroup = -1;
      this.region = [-1];
      this.marketCap = [-1];
      this.countries = undefined;
      if (
        this.route.snapshot &&
        this.route.snapshot.data &&
        this.route.snapshot.data.shortName
      ) {
        this.pageShortName = this.route.snapshot.data.shortName;
      }
      if (this.route.snapshot && this.route.snapshot.queryParams) {
        const queryParams = { ...this.route.snapshot.queryParams };
        if (queryParams.subgroup) {
          this.subGroup = parseInt(queryParams.subgroup);
        }
      }
      this.store.dispatch(new DeleteDpParams());
      if (this.sectorIndustryStoreSubscriber) {
        this.sectorIndustryStoreSubscriber.unsubscribe();
      }
      if (this.sectorIndustryStoreReloadSubscriber) {
        this.sectorIndustryStoreReloadSubscriber.unsubscribe();
      }
      if (this.sectorIndustryStoreHasDataSubscriber) {
        this.sectorIndustryStoreHasDataSubscriber.unsubscribe();
      }
      this.sectorIndustryStoreSubscriber = this.store
        .select(stateGetter("sectorIndustry"))
        .subscribe((_sectorIndustryState: SectorIndustry) => {
          if (
            _sectorIndustryState.hasCompaniesData &&
            _sectorIndustryState.facetSelectionSettings
          ) {
            this.industryId =
              _sectorIndustryState.facetSelectionSettings.industry_id;
            this.subGroup = _sectorIndustryState.facetSelectionSettings
              .subindustry_id
              ? _sectorIndustryState.facetSelectionSettings.subindustry_id[0]
              : -1;
            this.marketCap =
              _sectorIndustryState.facetSelectionSettings.market_cap;
            this.region = _sectorIndustryState.facetSelectionSettings.region_id;
            this.countries =
              _sectorIndustryState.facetSelectionSettings.country_id;
          }
          if (_sectorIndustryState.hasData) {
            this.sector = _sectorIndustryState.selectedSectorName;
            if (
              _sectorIndustryState.selectedIndustryId ===
              this.industryId.toString()
            ) {
              this.industry = _sectorIndustryState.selectedIndustryName;
            }
          }
        });

      this.sectorIndustryStoreReloadSubscriber = this.store
        .select(stateGetter("sectorIndustry", "reloadAll"))
        .subscribe((reloadAll: boolean) => {
          if (reloadAll) {
            this.fetchAndUpdateIndustryMeta();
          }
        });

      this.sectorIndustryStoreHasDataSubscriber = this.store
        .select(stateGetter("sectorIndustry", "hasData"))
        .subscribe((_hasData: boolean) => {
          if (!_hasData) {
            if (this.sectorMetaSubscriber) {
              this.sectorMetaSubscriber.unsubscribe();
            }
            this.sectorMetaSubscriber = this.dataService
              .getSectorMeta()
              .subscribe((_sectorMeta: SectorMetaResponse) => {
                const apiCalls = _sectorMeta.sectors.map((_sector) => {
                  return this.dataService.getIndustryDetailsBySector(
                    _sector.sector_id,
                  );
                });

                if (this.industryDetailsSubscriber) {
                  this.industryDetailsSubscriber.unsubscribe();
                }
                this.industryDetailsSubscriber = forkJoin(apiCalls).subscribe(
                  (_industries) => {
                    this.store.dispatch(
                      new SetSectorIndustry({
                        sectors: _sectorMeta,
                        industries: _industries,
                        industryId: this.industryId.toString(),
                        selectedCluster: this.subGroup,
                      }),
                    );
                  },
                );
              });
          }
        });

      // get Industry related meta on component initialization
      this.fetchAndUpdateIndustryMeta();

      this.megaMenuService.updateGlobalMenuLink(this.industryId);
      this.appService.logUserAction(
        {},
        "",
        "",
        ANALYTICS_FEATURE_NAME[this.pageShortName],
        {
          tab_name: this.pageShortName,
          industry_id: this.industryId,
        },
        "",
        INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
      );
    });
    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of common state to trigger data calls on all tabs
          if (!this.isMetaInProgress && this.gridData) {
            this.fetchAndHandleValuationData();
          }
        }
      });
  }

  //methods

  /**
   * It executes on industry change
   * Makes call to get Industry meta and updates the filters selection data according to it.
   * Makes call to get stdLines Info for the received tickers
   */
  fetchAndUpdateIndustryMeta() {
    this.isMetaInProgress = true;
    // reset filters on change of industry
    this.setDefaultFilters();

    if (this.valuationMetaSubscriber) {
      this.valuationMetaSubscriber.unsubscribe();
    }
    this.valuationMetaSubscriber = this.dataService
      .getIndustryMeta(
        this.industryId,
        this.pageShortName,
        this.subGroup,
        this.region,
        this.marketCap,
        this.countries,
      )
      .subscribe((response) => {
        if (response.status === "success") {
          const responseData = response.data;
          this.marketDataAccess = responseData.marketdata_access;
          if (!this.marketDataAccess) {
            this.snackbarInfo.message = `You are currently not entitled to view Market/Valuation data. Please reach out to your Customer Success Manager if you require access.`;
            this.snackbarInfo.type = "info";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }

          // store meta information
          this.updateStateWithMeta(responseData);
          this.store.dispatch(
            new SetIndustrySubHeader({
              data: {
                geographies: responseData.geographies,
                marketCaps: responseData.market_caps,
                subGroups: responseData.sub_groups,
              },
              selectedCluster: this.subGroup || -1,
            }),
          );
          const selectedRatioLineIds = this.ratios
            ? getSelectedRatiosId(this.ratios.ratio_details)
            : undefined;

          if (responseData.ticker_info.length === 0) {
            this.isNoTickerPopupVisible = true;
          } else if (
            !selectedRatioLineIds ||
            selectedRatioLineIds.length === 0
          ) {
            this.snackbarInfo.message = "No data Available.";
            this.snackbarInfo.type = "info";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }

          this.isMetaInProgress = false;
          if (
            !this.ratios ||
            !selectedRatioLineIds ||
            selectedRatioLineIds.length === 0 ||
            !this.tickers ||
            this.tickers.length === 0
          ) {
            this.gridData = undefined;
          } else {
            // make data calls
            this.fetchAndHandleValuationData();
            const tickerIds = this.tickers.map((item) => item.ticker);
            this.getPeriodsWithAvailableData(tickerIds);
          }

          if (responseData.ticker_info && responseData.ticker_info.length) {
            // Update stdLineItem on Tickers change
            const tickersWithOnlyId = responseData.ticker_info.map(
              (item) => item.ticker,
            );
            this.getRatioLineItemData(tickersWithOnlyId);
          }
        } else if (
          response.status_code === 403 &&
          window.location.href !== this.legacyUrl
        ) {
          window.location.href = `${this.legacyUrl}/home`;
        } else {
          console.error("Meta call failed");
        }
      });
  }

  /**
   * reset filters selection
   */
  setDefaultFilters() {
    this.suggestedRatioLines = [];
    this.ratios = [];
    this.tickers = [];
    this.currency = "";
    this.periodData = undefined;
    this.orientationValue = "grid";
  }

  /**
   * store meta details to variables
   *  @param {obj} meta: meta details
   */
  updateStateWithMeta(meta) {
    this.ratios = meta.ratios;
    this.region = meta.region;
    this.currency = meta.currency || "USD";
    this.tickers = meta.ticker_info
      ? meta.ticker_info.map((item) => ({
          ...item,
          tickerDeleteDisabled: true,
        }))
      : [];
    this.periodData = meta.period;
    const periodUserSettings = convertPeriodMetaToUserSettings(meta.period);
    this.periodUserSetting = periodUserSettings;
    this.periodList = getSelectedPeriods(meta.period);
    this.magnitudeMessage = meta.magnitude_message;
    this.periodCalculation = meta.period_calculation;
    this.selectedLineItemCount = (
      getSelectedRatiosId(meta.ratios.ratio_details) || []
    ).length;
    this.orientationValue = meta.orientation;
  }

  /**
   * It executes on the search and selection of line item
   * It adds this line item to existing list
   * @param {object} e: selected line item
   */
  onSearchedLi(e) {
    if (!e) {
      return;
    }

    const selectedRatioLineIds = this.ratios
      ? getSelectedRatiosId(this.ratios.ratio_details)
      : [];

    // check if already existing line items are more or equal to max limit. If yes don't add new item
    if (selectedRatioLineIds.length >= this.lineItemMaxLimit) {
      return;
    }

    const value = { ...e, parent: undefined, sliid: e.sliid || e.sli_id };
    const alreadyExist = selectedRatioLineIds.includes(value.sliid);

    if (!alreadyExist) {
      this.isUserSettingUpdateInProgress = true;

      //update the selected check of ratio item
      const updatedRatios = this.ratios.ratio_details.map((item) => {
        const ratioItem = item.ratio;
        if (ratioItem.usliid === value.sliid) {
          item.ratio.selected = true;
        }
        return item;
      });

      const updatedRatiosObj = {
        ...this.ratios,
        ratio_details: updatedRatios,
      };
      const userTabSettings = this.createUserTabSettings(
        updatedRatiosObj,
        this.periodUserSetting,
        this.orientationValue,
      );
      this.userTabSettingsSubscriber = this.dataService
        .saveUserIndustryTabSettings(this.pageShortName, userTabSettings)
        .subscribe((response: { status: string; data: IndustryMeta }) => {
          if (response.status === "success") {
            this.ratios = updatedRatiosObj;
            if (updatedRatios) {
              this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
              this.selectedLineItemCount = this.selectedRatioId.length;
              this.orderedRatioData = this.orderedRatioData
                ? this.orderedRatioData.concat(value)
                : undefined;
            }
            this.selectedLineItemCount = (
              getSelectedRatiosId(this.ratios.ratio_details) || []
            ).length;
            this.snackbarInfo.message = `${value.label} has been added to the table`;
            this.snackbarInfo.type = "success";
            this.showSnackBarToastMessage(this.snackbarInfo);
            this.fetchAndHandleValuationData();

            this.appService.logUserAction(
              {},
              "",
              "",
              "INDUSTRY_VALUATION_UPDATE_RATIO",
              {
                tab_name: this.pageShortName,
                tickers: this.getTickerIdArray(),
                ...this.createUserTabSettings(
                  this.ratios,
                  this.periodUserSetting,
                  this.orientationValue,
                ),
              },
              "",
              INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
            );
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.snackbarInfo.message = "This line item is already present.";
      this.snackbarInfo.type = "info";
      this.showSnackBarToastMessage(this.snackbarInfo);
    }
  }

  /**
   * It executes on the click of Edit button of lien item filter
   * It creates the Line item modal withe required information and opens it.
   */
  handleEditLineItemsButtonClick() {
    let selectedRatioItems = [];
    if (this.orderedRatioData) {
      selectedRatioItems = this.orderedRatioData;
    } else {
      selectedRatioItems = this.ratios.ratio_details
        .filter((item) => item.ratio.selected)
        .map((el) => {
          const sliId = el.ratio.usliid || el.ratio.sliid || el.ratio.el.sli_id;
          return {
            ...el.ratio,
            sli_id: sliId,
            name: el.ratio.label,
            is_valuation_ratio: true,
          };
        });
    }
    this.lineItemsModal = this.modalService.create({
      nzTitle: "Edit Line Items",
      nzOkLoading: true,
      nzContent: LineItemModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: selectedRatioItems,
        stdLineItems: this.ratioLineItemsData,
        max: this.lineItemMaxLimit,
        maxHeight: "290px",
        selectedPeriod: [],
        tickers: this.tickers,
        createSource: "consensus",
        ratioDenomData: this.ratios.include,
        showDenomCheckbox:
          this.orientationValue && this.orientationValue === "grid",
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.lineItemsModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          nzClassName: (data) => {
            return data.modalData.length > data.max ? "disable" : "";
          },
          onClick: (data): void => {
            this.updateEditModalLineItems(data);
          },
          disabled: (data) => {
            return (
              data.modalData.length > data.max || data.modalData.length === 0
            );
          },
        },
      ],
    });
  }

  /**
   * It adds line items selected from the edit modal to the list
   * @param {object} data: selected data from line item modal
   */
  updateEditModalLineItems(data) {
    const { modalData, selectedRatioDenomItems = [] } = data;
    this.orderedRatioData = [...modalData];
    this.isUserSettingUpdateInProgress = true;
    const selectedRatioItems = modalData.map(
      (item) => item.uniquesliid || item.sliid || item.sli_id,
    );
    //update the selected check of ratio item
    const updatedRatios = this.ratios.ratio_details.map((item) => {
      const ratioItem = item.ratio;
      item.ratio.selected = selectedRatioItems.includes(ratioItem.usliid);
      return item;
    });

    const updatedIncludes = this.ratios.include.map((item) => ({
      ...item,
      selected: selectedRatioDenomItems.includes(item.name),
    }));

    const updatedRatiosObj = {
      ratio_details: updatedRatios,
      include: updatedIncludes,
    };
    const orderedRatioItems = this.orderedRatioData
      ? this.orderedRatioData.map(
          (item) => item.uniquesliid || item.sliid || item.sli_id,
        )
      : undefined;
    const userTabSettings = this.createUserTabSettings(
      updatedRatiosObj,
      this.periodUserSetting,
      this.orientationValue,
    );
    userTabSettings["ratios"]["names"] = orderedRatioItems;
    this.userTabSettingsSubscriber = this.dataService
      .saveUserIndustryTabSettings(this.pageShortName, userTabSettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.ratios = updatedRatiosObj;
          if (updatedRatios) {
            this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
            this.selectedLineItemCount = this.selectedRatioId.length;
          }
          this.selectedLineItemCount = (
            getSelectedRatiosId(this.ratios.ratio_details) || []
          ).length;
          this.fetchAndHandleValuationData();

          this.appService.logUserAction(
            {},
            "",
            "",
            "INDUSTRY_VALUATION_UPDATE_RATIO",
            {
              tab_name: this.pageShortName,
              tickers: this.getTickerIdArray(),
              ...this.createUserTabSettings(
                this.ratios,
                this.periodUserSetting,
                this.orientationValue,
              ),
            },
            "",
            INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
          );
        }
        this.isUserSettingUpdateInProgress = false;
      });
    this.lineItemsModal.destroy();
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
    };
    if (typeMap[type]) {
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: 5000,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  /**
   * Returns array of tickers id from array of tickers object.
   * @returns {array} - array of ticker id
   */
  getTickerIdArray() {
    return this.tickers ? this.tickers.map((item) => item.ticker) : [];
  }

  /**
   * It call the get_std_line_items api and formats the response
   */
  getRatioLineItemData(tickerIds) {
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    this.isLineItemUpdateInProgress = true;
    this.lineItemsSubscriber = this.valuationDataService
      .getStdLineItems(tickerIds)
      .subscribe((res) => {
        this.ratioLineItemsData = res.data.filter(
          (d) => d.tab_short_name === "SL" || d.tab_short_name === "VR",
        );
        if (this.ratios) {
          this.selectedRatioId =
            getSelectedRatiosId(this.ratios.ratio_details) || [];
          this.selectedLineItemCount = this.selectedRatioId.length;
        }
        const _suggestedLines: Array<any> = res.data.filter(
          (d) => d.tab_short_name === "SL",
        );
        this.suggestedRatioLines = _suggestedLines.length
          ? _suggestedLines[0].tab_sli_data.map((l) => {
              return {
                ...l,
                disabled: false,
                label: l.name,
                isLeaf: true,
                level: 2,
                header: false,
                sliid: l.sli_id,
                line_count: l.line_count,
                id: l.uniquesliid,
              };
            })
          : [];

        if (this.suggestedRatioLines.length > 0) {
          this.suggestedRatioLines = [
            {
              suggestion_header: "Suggestions: ",
              isLeaf: true,
              disabled: true,
            } as any,
          ]
            .concat(this.suggestedRatioLines)
            .concat({
              suggestion_footer: "Selected Line Items",
              isLeaf: true,
              disabled: true,
            } as any);
        } else {
          this.suggestedRatioLines = [
            {
              suggestion_header: "No suggestion found ",
              isLeaf: true,
              disabled: true,
            } as any,
          ]
            .concat(this.suggestedRatioLines)
            .concat({
              suggestion_footer: "Selected Line Items",
              isLeaf: true,
              disabled: true,
            } as any);
        }
        this.isLineItemUpdateInProgress = false;
      });
  }

  /**
   * get object required to make valuation data call
   */
  getDataCallObject() {
    return {
      ticker_info: this.tickers,
      currency: this.currency,
      period: this.periodData,
      ratios: this.ratios,
      period_calculation: this.periodCalculation,
      defaultOrientation: this.orientationValue,
      magnitudeMsg: this.magnitudeMessage,
    };
  }

  /**
   * It is used to trigger valuation data call for peer tab and store the result in gridData
   */
  fetchAndHandleValuationData() {
    if (this.valuationDataSecondBatchSubscriber) {
      this.valuationDataSecondBatchSubscriber.unsubscribe();
    }
    if (this.valuationDataFirstBatchSubscriber) {
      this.valuationDataFirstBatchSubscriber.unsubscribe();
    }
    if (this.valuationDataSubscriber) {
      this.valuationDataSubscriber.unsubscribe();
    }
    this.isDataInProgress = true;

    const dataCallObject = this.getDataCallObject();
    const orderedRatioItems = this.orderedRatioData
      ? this.orderedRatioData.map(
          (item) => item.uniquesliid || item.sliid || item.sli_id,
        )
      : undefined;
    let gridData = createGridData(dataCallObject, orderedRatioItems);
    this.gridData = { ...gridData };
    const ratios = [...this.gridData.ratios];

    const singleTickerCallCount = 20;
    const firstSetOfTicker = dataCallObject.ticker_info.slice(
      0,
      singleTickerCallCount,
    );
    const remainingSetOfTickers = dataCallObject.ticker_info.slice(
      singleTickerCallCount,
      dataCallObject.ticker_info.length,
    );
    const urls: Array<string> = createDataCallUrlV1(
      ratios,
      dataCallObject,
      firstSetOfTicker,
      singleTickerCallCount,
    );

    let firstBatchSubscriptionIndex = 0;
    this.valuationDataSubscriber = new Observable((observer) => {
      this.valuationDataFirstBatchSubscriber = from(urls)
        .pipe(
          mergeMap((url) => {
            return this.valuationDataService.getValuationDataCall(url);
          }),
        )
        .subscribe((response: { data; status }) => {
          if (response.status === "success") {
            const data = response.data;
            gridData = this.valuationDataService.addDataToGridV1(
              data,
              gridData,
              dataCallObject,
            );
          } else {
            console.error("Error while fetching valuation data");
          }
          firstBatchSubscriptionIndex++;
          if (
            (!remainingSetOfTickers || !remainingSetOfTickers.length) &&
            firstBatchSubscriptionIndex === urls.length
          ) {
            observer.next(gridData);
            observer.complete();
          }
        });

      if (remainingSetOfTickers && remainingSetOfTickers.length) {
        const maxParallelCallsForRemainingBatchOfTickers = 40;
        const nextBatchOfUrls: Array<string> = createDataCallUrlV1(
          ratios,
          dataCallObject,
          remainingSetOfTickers,
          maxParallelCallsForRemainingBatchOfTickers,
        );
        let remainingBatchSubscriptionIndex = 0;
        this.valuationDataService
          .createDelayUsingTimer(1000)
          .pipe()
          .subscribe(() => {
            this.valuationDataSecondBatchSubscriber = from(nextBatchOfUrls)
              .pipe(
                mergeMap((url) => {
                  return this.valuationDataService.getValuationDataCall(url);
                }),
              )
              .subscribe((response: { data; status }) => {
                remainingBatchSubscriptionIndex++;
                if (response.status === "success") {
                  const data = response.data;
                  gridData = this.valuationDataService.addDataToGridV1(
                    data,
                    gridData,
                    dataCallObject,
                  );
                } else {
                  console.error("Error while fetching valuation data");
                }
                if (
                  remainingBatchSubscriptionIndex === nextBatchOfUrls.length
                ) {
                  observer.next(gridData);
                  observer.complete();
                }
              });
          });
      }
    }).subscribe((gridData: ValuationGridData) => {
      this.gridData = { ...gridData };
      this.gridData = this.valuationDataService.calculateFooterData(
        gridData,
        dataCallObject.currency,
      );
      this.isDataInProgress = false;
      this.appService.logUserAction(
        {},
        "",
        "",
        "INDUSTRY_VALUATION_DATA",
        {
          tab_name: this.pageShortName,
          tickers: this.getTickerIdArray(),
          ...this.createUserTabSettings(
            this.ratios,
            this.periodUserSetting,
            this.orientationValue,
          ),
        },
        "",
        INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
      );
    });
  }

  /**
   * This method is called on change of the orientation button.
   * It updates the value of Orientation in the state and calls
   * saveusersettings api to save it.
   * @param e orientation value
   */
  handleOrientation(e) {
    this.isUserSettingUpdateInProgress = true;
    const userTabSettings = this.createUserTabSettings(
      this.ratios,
      this.periodUserSetting,
      e,
    );
    this.userTabSettingsSubscriber = this.dataService
      .saveUserIndustryTabSettings(this.pageShortName, userTabSettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.orientationValue = e;

          this.appService.logUserAction(
            {},
            "",
            "",
            "INDUSTRY_VALUATION_UPDATE_VIEW_ORIENTATION",
            {
              tab_name: this.pageShortName,
              tickers: this.getTickerIdArray(),
              ...this.createUserTabSettings(
                this.ratios,
                this.periodUserSetting,
                this.orientationValue,
              ),
            },
            "",
            INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
          );
        }
        this.isUserSettingUpdateInProgress = false;
      });
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the selected period setting to user setting api
   * It emits `onPeriodChange` with selected periodData
   * @param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodApply(periodData: {
    updatedPeriodData: ValuationPeriodState;
    periodUserSettingData: PeriodUserSettingObj;
  }) {
    const { updatedPeriodData, periodUserSettingData } = periodData;

    this.isUserSettingUpdateInProgress = true;
    const userTabSettings = this.createUserTabSettings(
      this.ratios,
      periodUserSettingData,
      this.orientationValue,
    );
    this.userTabSettingsSubscriber = this.dataService
      .saveUserIndustryTabSettings(this.pageShortName, userTabSettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.periodData = updatedPeriodData;
          this.periodUserSetting = periodUserSettingData;
          this.fetchAndHandleValuationData();

          this.appService.logUserAction(
            {},
            "",
            "",
            "INDUSTRY_VALUATION_UPDATE_PERIOD",
            {
              tab_name: this.pageShortName,
              tickers: this.getTickerIdArray(),
              ...this.createUserTabSettings(
                this.ratios,
                this.periodUserSetting,
                this.orientationValue,
              ),
            },
            "",
            INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
          );
        }
        this.isUserSettingUpdateInProgress = false;
      });
  }

  /**
   * This function is fired when the save currency event is fired from the currency filter component.
   * It updates the currency in the state and calls the saveusersettings api to save it.
   * @param item selected currency
   */
  updateCurrency(item: string) {
    if (!item) {
      return;
    }
    this.isUserSettingUpdateInProgress = true;
    const userIndustrySettings = createUserIndustrySettings(
      item,
      this.industryId,
      this.subGroup,
    );
    this.userIndustrySettingsSubscriber = this.dataService
      .saveUserIndustrySettings(userIndustrySettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.currency = item;
          this.currencyMessageSubscriber = this.compsDataService
            .getCurrencyMessage(item)
            .subscribe((res) => {
              if (res["status"] === "success") {
                this.magnitudeMessage = res["magnitude_message"];
                this.fetchAndHandleValuationData();

                this.appService.logUserAction(
                  {},
                  "",
                  "",
                  "INDUSTRY_VALUATION_UPDATE_CURRENCY",
                  {
                    tab_name: this.pageShortName,
                    tickers: this.getTickerIdArray(),
                    ...this.createUserTabSettings(
                      this.ratios,
                      this.periodUserSetting,
                      this.orientationValue,
                    ),
                  },
                  "",
                  INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
                );
              } else {
                this.snackbarInfo.message = "Could not update currency";
                this.snackbarInfo.type = "failure";
                this.showSnackBarToastMessage(this.snackbarInfo);
              }
              this.isUserSettingUpdateInProgress = false;
            });
        }
      });
  }

  /**
   * It creates user tab settings object
   * @param {object} ratio - ratio data
   * @param {object} period - period settings
   * @param {object} orientation - selected orientation value
   * @return {object} user tab setting object which is used to save the selected filters
   */
  createUserTabSettings(
    ratios,
    period: PeriodUserSettingObj,
    orientation: string,
  ) {
    const selectedRatioId = getSelectedRatiosId(ratios.ratio_details);
    const denom = getIsDenomSelected(ratios.include);
    const denomYoy = getIsDenomYoySelected(ratios.include);
    return {
      ratios: {
        names: selectedRatioId,
        denom,
        denom_yoy: denomYoy,
      },
      period,
      orientation,
      industry_id: this.industryId,
      subindustry_id: [this.subGroup],
    };
  }

  /**
   * Executes on click of export dropdown list item
   * It closes the dropdown on selecting list items. Also one can update the loader status when excel to export action is in progress
   * @param {id} number Indicates the id of selected list item from optionList
   */
  handleETEListItemClick(exportType) {
    this.isExportInProgress = true;
    let templateType = "";
    const tabName = "Valuation";
    if (this.orientationValue === "grid") {
      templateType = "industry valuation grid";
    }
    if (this.orientationValue === "list") {
      templateType = "industry valuation list";
    }
    const params = `industry_id=${this.industryId}&tab=${this.pageShortName}&export_type=${exportType}&template_type=${templateType}&sector_name=${this.sector}&industry_name=${this.industry}&page_name=${tabName}`;
    this.dataService
      .downloadIndustryExport(
        params,
        this.subGroup,
        this.region,
        this.marketCap,
        this.countries,
      )
      .subscribe(
        (res) => {
          if (res["status"] === "success") {
            const fileName = res["filename"];
            const trackerId = res["trackerid"];
            const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
            const startIFrameTime = new Date().getTime();
            const iFrameToLoad = this._document.createElement("iframe");
            const body = this._document.getElementsByTagName("body")[0];
            iFrameToLoad.id = `${fileName}`;
            iFrameToLoad.name = `${fileName}`;
            iFrameToLoad.src = downloadUrl;
            iFrameToLoad.setAttribute(
              "style",
              "visibility:hidden;display:none",
            );
            body.appendChild(iFrameToLoad);

            const checkInterval = setInterval(() => {
              const iFrameToGet = this._document.getElementById(
                `${fileName}`,
              ) as HTMLIFrameElement;
              const iFrame =
                iFrameToGet.contentDocument ||
                iFrameToGet.contentWindow.document;
              /*
              This check will run till the iFrame either doesn't load or for a max of 30secs
              Or till the ready state of the iFrame doesn't evaluate
            */
              if (
                iFrame.readyState === "complete" ||
                iFrame.readyState === "interactive" ||
                new Date().getTime() - startIFrameTime > 30000
              ) {
                //Commenting for now
                // this._document
                //   .getElementById(`research_download_${dataToPass.id}`)
                //   .remove();
                clearInterval(checkInterval);
                return;
              }
            }, 2000);
            this.isExportInProgress = false;
            // iframe.onload = () => {
            //   setTimeout(function() {
            //     document.getElementById(`research_download_${dataToPass.id}`).remove();
            //   }, 100);
            //   this.loading = false;
            // };
            this.appService.logUserAction(
              {},
              "",
              "",
              "INDUSTRY_VALUATION_EXCEL_EXPORT",
              {
                tab_name: this.pageShortName,
                industry_id: this.industryId,
                export_type: exportType,
                tracker_id: trackerId,
                file_name: fileName,
              },
              "",
              INDUSTRY_PAGE_INFO.valuation.pageNameForTracking,
            );
          } else {
            this.isExportInProgress = false;
            this.snackbarInfo.message =
              "Industry export couldn't be downloaded.";
            this.snackbarInfo.type = "failure";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
        },
        (err) => {
          this.isExportInProgress = false;
          console.error(err);
        },
      );
  }

  /**
   * Handler for mega menu visibility change event
   */
  onMegaMenuVisibilityChange(isVisible: boolean) {
    this.isMegaMenuVisible = isVisible;
  }

  /**
   * Executes on Change now button click of no ticker popup
   * It hides the no ticker popup and shows region filter popup
   */
  onNoTickerPopupChangeClick() {
    this.isNoTickerPopupVisible = false;
    if (this.store) {
      this.store.dispatch(
        new SetIndustryMengMenuVisibility({
          isIndustryMegaMenuVisible: true,
        }),
      );
    }
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }
}
